import React, { useEffect } from "react"
import { Text, Flex, Center, Heading } from "@chakra-ui/layout"
import { Image } from "@chakra-ui/image"
import { StaticImage } from "gatsby-plugin-image"
import { Link } from "gatsby"

import ResponsiveBlock from "~components/shared/layout/responsive-block"
import SEO from "~components/shared/SEO"
import Corgi from "~images/pages/book-a-demo/excited-corgi.webp"

const BookADemoPage: React.FC = () => {
    useEffect(() => {
        if (typeof document === "undefined") return
        const src =
            "https://tag.simpli.fi/sifitag/52d61c82-9d58-4a45-b42d-9891bb2dcbfb"
        const existing = document.querySelector(`script[src="${src}"]`)
        if (existing) return
        const script = document.createElement("script")
        script.async = true
        script.src = src
        document.head.appendChild(script)
    }, [])

    return (
        <Flex
            w="100vw"
            h="100vh"
            bgGradient="linear(to-b, white, gray.100)"
            flexDir="column"
            pt={16}
            overflow="hidden"
            px={8}
        >
            <ResponsiveBlock>
                <Link to="/">
                    <StaticImage
                        src="../../images/logo/png/default-w-chckup.png"
                        alt="Chckvet Logo"
                        placeholder="blurred"
                        width={196}
                    />
                </Link>
            </ResponsiveBlock>
            <Center flexDir="column" flex={1} gap={4} overflow="hidden">
                <Image
                    src={Corgi}
                    alt="A corgi that is excited to see you! 🎉"
                    placeholder="blurred"
                    width={240}
                />
                <Heading>See you soon! 🎉</Heading>
                <Heading size="md">Thank you for booking a demo</Heading>
                <Text>
                    We can't wait to show you how Chckvet can help you grow your
                    business.
                </Text>
            </Center>
        </Flex>
    )
}

export default BookADemoPage

export const Head = () => (
    <SEO
        title="Demo Booked - Thank You!"
        description="Thank you for booking your Chckvet demo! We can't wait to show you how our veterinary practice management platform can help grow your business."
        noindex
    />
)
